
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.5 4A1.5 1.5 0 0110 5.5v13a1.5 1.5 0 01-3 0v-13A1.5 1.5 0 018.5 4zM15.5 4A1.5 1.5 0 0117 5.5v13a1.5 1.5 0 01-3 0v-13A1.5 1.5 0 0115.5 4z"}})])
          )
        }
      }
    